export default __webpack_public_path__ + "static/hero-djcard1-b493465d5b95d0465ffded2b37ed3c1f.webp";